import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
    // 左右按钮
    // 只启用一个 pagination（进度条）
    navigation: {
        nextEl: ".banner .swiper-button-next",
        prevEl: ".banner .swiper-button-prev",
    },
}); 

$(".section1 .product-nav ul li").eq(0).addClass("active");
$(".section1 .product-pic .pic").eq(0).addClass("active"); 
$(".section1 .product-text .text").eq(0).addClass("active"); 
$(".section1 .product-nav ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section1 .product-pic .pic").eq(index).addClass("active").siblings().removeClass("active");
    $(".section1 .product-text .text").eq(index).addClass("active").siblings().removeClass("active");
})

function countUp(el){
    let target = parseFloat(el.data('num'));
    $({count:0}).animate(
        {count:target},
        {
            duration:2000,
            step:function(now){
                el.text(Math.floor(now));
            },
            complete:function(){
                el.text(target);
            }
        }
    );
}

let played1 = false;
$(window).on('scroll',function(){
    let top = $('.section3 .stats').offset().top;
    let winTop = $(window).scrollTop();
    let winH = $(window).height();
    if(!played1 && winTop + winH > top){
        played1 = true;
        $('.section3 .item').each(function(index){
            let _this = $(this);
            setTimeout(function(){
                _this.addClass('show');
                countUp(
                    _this.find('.num')
                );
            },index * 250);
        });
    }
}).trigger('scroll');

var h_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.section3 .content .text').each(function() { //遍历相同样式名的元素
    var h = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    h_max = h > h_max ? h : h_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.section3 .content .text').height(h_max); //给每一个元素设置相同的高度	

var swiperLeft = new Swiper(".swiper-left", {
    loop:true,
    speed:4000,//匀速时间
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3.36,
            spaceBetween: 24,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1.3,
            spaceBetween: 10, 
        }
    }  
}); 